import React from "react";
import { Helmet } from "react-helmet";

import {
  Navbar,
  Footer,
  Landing,
  About,
  Testimonials,
  Blog,
  Education,
  Experience,
  Contacts,
  Projects,
  Services,
  Achievement,
} from "../../components";
import SkillsTest from "../../components/Skills/SkillsTest";
import { useState,useEffect } from "react";
import Loader from "../../components/Loader/Loader";

import { headerData } from "../../data/headerData";
import EducationTest from "../../components/Education/EducationTest";
import Project2 from "../../components/Projects/Project2";
import Achievement2 from "../../components/Achievement/Achievement2";
import Background from "../../components/Background/Background";
import Contacts2 from "../../components/Contacts/Contacts2";
import { LanguageProvider } from "../../contexts/LanguageContext";

function Main() {
  const [loading, setLoading] = useState(true);

  console.log("headerData", window.innerWidth);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setLoading(false);
  //   }, 0); // Attendre 7 secondes avant d'afficher le reste du contenu

  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <LanguageProvider>
      <Helmet>
        <title>{headerData.name.en} - Portfolio</title>
      </Helmet>
{/* 
      {loading ? (
        <Loader />
      ) : (
        <> */}
          <Navbar />
          <Landing />
          <About />
          <EducationTest />
          {/* <Experience /> */}
          <SkillsTest />
          <Project2 />
          <Achievement2 />
          <Contacts2 />
        {/* </>
      )} */}
    </LanguageProvider>
  );
}

export default Main;
